import { EventEmitter, Injectable, OnDestroy, signal } from "@angular/core";
import { fromEvent, map, merge, of, Subscription } from "rxjs";
import { LoaderService } from "../shared/loader/loader.service";

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusLineService implements OnDestroy {
//   private onlineSubscription: Subscription | undefined;
    private networkStatusSubscription: Subscription | undefined;
 
    public changeStatusLine : EventEmitter<boolean> = new EventEmitter<boolean>();

    offline = signal(false);
    constructor(private loaderService: LoaderService) {
        this.checkNetworkStatus();
    }
    ngOnDestroy(): void {
       this.networkStatusSubscription?.unsubscribe();
    }
   
    public checkNetworkStatus() {
    
        this.offline.update(() =>!navigator.onLine); 
        this.networkStatusSubscription = merge(
          of(null),
          fromEvent(window, 'online'),
          fromEvent(window, 'offline')
        )
          .pipe(map(() => navigator.onLine))
          .subscribe(status => {
            console.log('status', status);
            this.offline.update(() => !status);
             
            this.changeStatusLine.emit(status);
          });
      
       
      }
    
}